import React, { RefObject, useEffect, useRef, useState } from 'react';
// import "../assets/plugins/select2/select2.full.min.js"
import "./Dashboard.scss"
import SalesChart from "./charts/SalesChart";
import CardTypeChart from "./charts/CardTypeChart";
import { IBarChartData, IPeriodIndicator } from "../models/IBarChartData";
import { DashboardService } from "../services/DashboardService";
import { UtilService } from "../services/UtilService";
import { IPieChartData, IRejectionIndicator } from "../models/IPieChartData";
import { useTranslation } from "react-i18next";
import { TransactionService } from "../services/TransactionService";
import { AxiosResponse } from "axios";
import { ITransaction } from "../requests/ITransactionWebModelRequest";
import { DateObject } from "react-multi-date-picker";
import AmountIndicator from "./charts/AmountIndicator";
import CountIndicator from "./charts/CountIndicator";
import CouponPromIndicator from "./charts/CouponPromIndicator";
import ApprovalRateIndicator from "./charts/ApprovalRateIndicator";
import AmountByIssuerChart from "./charts/AmountByIssuerChart";
import CountByIssuerChart from "./charts/CountByIssuerChart";
import RejectionByIssuerChart from "./charts/RejectionByIssuerChart";
import RankingChart from "./charts/RankingChart";
import i18next from "i18next";
import ReactToPrint from "react-to-print";
import { CurrencyHelper } from '../helpers/CurrencyHelper';
import Card from './containers/card';
import NetAmountIndicator from './charts/NetAmountIndicator';
import TaxIndicator from './charts/TaxIndicator';
import Page from '../components/containers/page';
import { WebCache } from '../services/WebCache';
import TariffIndicator from "./charts/TariffIndicator";
import CustomTable, { TableModeEnum } from './table/CustomTable';
import { IIssuerTotalDto } from '../models/IIssuerTotalDto';
import { Modal } from 'react-bootstrap';
import { TransactionColumns } from './transactions/TransactionsColumns';
import { CarouselImage } from '../models/ICarouselImage';
import { getAllImages } from '../utils/db';
import { Carousel } from 'react-bootstrap';
import Accordion from "react-bootstrap/Accordion";
import { ReactComponent as FlagAr } from "../../node_modules/itd-common/assets/images/flags/ar.svg";
import { ReactComponent as FlagUy } from "../../node_modules/itd-common/assets/images/flags/uy.svg";
import { ReactComponent as FlagUsa } from "../../node_modules/itd-common/assets/images/flags/us.svg";
import Select from 'react-select';
import NpsSurvey from './terminals/NpsSurvey';


const T_PREFIX: string = 'pages.Dashboard.';
interface IState {
    to_date: DateObject,
    dateRange: string,
    currency: ICurrency,
    allTotal: IBarChartData,
    longPeriodIndicator: IPeriodIndicator,
    shortPeriodIndicator: IPeriodIndicator,
    conciliationShortPeriodIndicator: IPeriodIndicator,
    conciliationNextPeriodIndicator: IPeriodIndicator,
    upToDate: boolean,
    approvalRateIndicator: IPeriodIndicator,
    rejectionIndicators: IRejectionIndicator,
    reverseIndicators: IPieChartData,
    issuerTotals: IPieChartData,
    acquirerTotals: IPieChartData,
    cardTypeTotals: IPieChartData,
    totalByChannel: IPieChartData,
    totalByWallet: IPieChartData,
    planTotals: IPieChartData,
    totalByBrand: IPieChartData,
    transactionTypeTotals: IBarChartData,
    errorMessage: string,
    reload: boolean,
    transactions: ITransaction[],
    columns: Array<string>
    errors: string[],
    activePage: number,
    mainPage: number,
    pages: number[],
    show: boolean,
    issuersByTotal: IIssuerTotalDto[],
    tranId: string
    carouselImages: CarouselImage[],
    fetchMainDashboard: boolean,
}
interface IProps {
}

interface ICurrency {
    id: string;
    name: string;
}

let Dashboard: React.FC<IProps> = () => {
    const [accordionOpen, setAccordionOpen] = useState<boolean>(false);
    const [showNpsModal, setShowNpsModal] = useState<boolean>(false);
    const { t } = useTranslation();
    const initialCurrency = WebCache.getCurrencies()[0]?.id || "";
    const [selectedCurrency, setSelectedCurrency] = useState<string>(initialCurrency);
    const [transactions, setTransactions] = useState<ITransaction[]>([]);
    const [transactionsLoaded, setTransactionsLoaded] = useState<boolean>(false);
    const [columns, setColumns] = React.useState<string[]>([]);
    const [dashboardLoaded, setDashboardLoaded] = React.useState<boolean>(false);
    let toDate = new DateObject();

    let [state, setState] = useState<IState>({
        to_date: toDate,
        upToDate: false,
        dateRange: 'today',
        currency: WebCache.getCurrencies()[0],
        carouselImages: [],
        allTotal: {
            rows: [{
                label: "",
                color: "",
                values: [],
                count: []
            }],
            labels: []
        },
        transactionTypeTotals: {
            rows: [{
                label: "",
                color: "",
                values: [],
                count: []
            }],
            labels: []
        },
        issuerTotals: {
            colors: [],
            counts: [],
            labels: [],
            values: []
        },
        acquirerTotals: {
            labels: [],
            colors: [],
            values: [],
            counts: []
        },
        cardTypeTotals: {
            labels: [],
            colors: [],
            values: [],
            counts: []
        },
        totalByChannel: {
            labels: [],
            colors: [],
            values: [],
            counts: []
        },
        totalByWallet: {
            labels: [],
            colors: [],
            values: [],
            counts: []
        },
        planTotals: {
            labels: [],
            colors: [],
            values: [],
            counts: []
        },
        totalByBrand: {
            labels: [],
            colors: [],
            values: [],
            counts: []
        },
        longPeriodIndicator: DashboardService.createIPeriodIndicator([]),
        shortPeriodIndicator: DashboardService.createIPeriodIndicator([]),
        conciliationNextPeriodIndicator: DashboardService.createIPeriodIndicator([]),
        approvalRateIndicator: DashboardService.createIPeriodIndicator([]),
        conciliationShortPeriodIndicator: DashboardService.createIPeriodIndicator([]),
        errorMessage: "",
        reload: false,
        rejectionIndicators: {
            labels: [],
            colors: [],
            values: [],
            authValues: [],
            authCounts: [],
            totalCount: 0,
            counts: []
        },
        reverseIndicators: {
            labels: [],
            colors: [],
            values: [],
            counts: []
        },
        transactions: [],
        errors: [],
        columns: [
        ],
        activePage: 1,
        mainPage: 0,
        pages: [1],
        show: false,
        issuersByTotal: [],
        tranId: "",
        fetchMainDashboard: false
    });

    const pageSize = 10;

    useEffect(() => {

        if (!transactionsLoaded) {
            const { to_date } = state;
            const to_year = to_date.year;
            const to_month = to_date.month.number;
            const to_day = to_date.day;
            const currencyId = state.currency?.id || (WebCache.getCurrencies()[0]?.id ?? "");

            TransactionService.getAllForDashboard({
                From: UtilService.getYYYY_MM_DDMinusDaysFormat(365), To: new Date(to_year,
                    to_month - 1,
                    to_day,
                    23,
                    59).toJSON(),
                Currency: currencyId,
                Skip: 0, Take: pageSize
            })
                .then((response: AxiosResponse<ITransaction[]>) => {
                    if (!response || !response.data || response.data.length === 0) {
                        setTransactions([]);
                        setColumns([]);
                        setTransactionsLoaded(true);
                        return;
                    }
                    // Obtener las columnas del primer elemento de la respuesta
                    const newColumns = Object.keys(response.data[0]);
                    // Actualizar el estado con los datos y las columnas
                    setTransactions(response.data);
                    setColumns(newColumns);
                    setTransactionsLoaded(true);
                })
                .catch(error => {
                    setTransactionsLoaded(true);
                    setTransactions([]);
                    setColumns([]);
                    console.error("Error:", error);
                });
        }
    }, [transactionsLoaded, state.currency]);

    let refreshData = (fetchSettlementDashboard: boolean): void => {
        state.reload = true;
        let startDate = UtilService.getYYYY_MM_DDFormat(new Date());
        let endDate = UtilService.getYYYY_MM_DDFormat(new Date());
        let accumulationCriteria = "Day";
        if (state.dateRange === "yesterday") {
            startDate = UtilService.getYYYY_MM_DDMinusDaysFormat(1);
            endDate = startDate;
        } else if (state.dateRange === "7days") {
            accumulationCriteria = "Week"
            startDate = UtilService.getYYYY_MM_DDMinusDaysFormat(6);
        } else if (state.dateRange === "30days") {
            accumulationCriteria = "Month"
            startDate = UtilService.getYYYY_MM_DDMinusDaysFormat(30);
        } else if (state.dateRange === "1year") {
            accumulationCriteria = "Year"
            startDate = UtilService.getYYYY_MM_DDMinusDaysFormat(365);
        }

        if (state.fetchMainDashboard) {
            DashboardService.getDashboard(startDate, endDate, state.currency?.id, accumulationCriteria).then((response) => {
                let data = response.data;
                state.allTotal = data.allTotal;
                state.issuerTotals = data.totalByIssuer;
                state.totalByWallet = data.totalByWallet;
                state.acquirerTotals = data.totalByAcquirer;
                if (state.acquirerTotals != null && state.acquirerTotals.labels != null)
                    for (var i in state.acquirerTotals.labels) {
                        state.acquirerTotals.labels[i] = i18next.t(state.acquirerTotals.labels[i]) as never;
                    }
                state.cardTypeTotals = filterPieChartData(data.totalByCardType);
                state.totalByChannel = filterPieChartData(data.totalByChannel);
                state.totalByBrand = data.totalByBrand;
                if (WebCache.isUserUYU()) { //las cuotas no vienen de b24 por lo que si es arg se saca de la liqudiacion
                    state.planTotals = data.totalByPlanType;
                    if (state.planTotals != null && state.planTotals.labels != null)
                        for (var i in state.planTotals.labels) {
                            if (state.planTotals.labels[i] == "0")
                                state.planTotals.labels[i] = i18next.t("cash") as never;
                            else
                                state.planTotals.labels[i] = state.planTotals.labels[i] + " " + i18next.t("quotas") as never;
                        }
                }
                state.transactionTypeTotals = data.totalByTransactionType;
                state.longPeriodIndicator = data.longPeriodIndicator;
                state.shortPeriodIndicator = data.shortPeriodIndicator;
                state.approvalRateIndicator = data.approvalRateIndicator;
                state.rejectionIndicators = filterRejectionIndicators(data.rejectionIndicators);
                state.reverseIndicators = data.reverseIndicators;
                if (fetchSettlementDashboard)
                    fetchSettDashboard(startDate, endDate, accumulationCriteria, data);
                else {
                    setState({
                        ...state,
                        allTotal: data.allTotal,
                        reload: false
                    })
                }
            }).catch((error) => {
                setState({
                    ...state,
                    errorMessage: t ? t('errorLoadingDashboard') : 'Ocurrió un error al cargar el dashboard.',
                    reload: true
                });
                console.error('Dashboard error:', error);
            });
        } else if (fetchSettlementDashboard) {
            fetchSettDashboard(startDate, endDate, accumulationCriteria, { allTotal: state.allTotal });
        } else {
            setState({
                ...state,
                reload: true
            });
        }
    }

    useEffect(() => {
        setState(prevState => ({ ...prevState, initDahboard: false }));
        if (!dashboardLoaded) {
            setDashboardLoaded(true)
            refreshData(true);
        }
    }, [state.currency, state.fetchMainDashboard]);

    const getFlagComponent = (id: string) => {
        if (id === "32") return <FlagAr style={{ width: 24, height: 16 }} />;
        if (id === "840") return <FlagUsa style={{ width: 24, height: 16 }} />;
        if (id === "858") return <FlagUy style={{ width: 24, height: 16 }} />;
        return null;
    };

    const currencyOptions = WebCache.getCurrencies()
        .filter(currency => ["32", "840", "858"].includes(currency?.id))
        .map(currency => ({
            value: currency?.id,
            label: getFlagComponent(currency?.id),
        }));

    const fetchSettDashboard = (startDate: string, endDate: string, accumulationCriteria: string, data: any) => {
        DashboardService.getSettlementDashboard(startDate, endDate, state.currency?.id, accumulationCriteria).then((response) => {
            state.conciliationShortPeriodIndicator = response.data.shortPeriodIndicator;
            state.conciliationNextPeriodIndicator = response.data.nextPeriodIndicator;
            state.upToDate = response.data.dataUpToDate;
            if (!WebCache.isUserUYU()) {
                state.planTotals = response.data.totalByPlanType;
                if (state.planTotals != null && state.planTotals.labels != null)
                    for (var i in state.planTotals.labels) {
                        if (state.planTotals.labels[i] == "0")
                            state.planTotals.labels[i] = i18next.t("cash") as never;
                        else
                            state.planTotals.labels[i] = state.planTotals.labels[i] + " " + i18next.t("quotas") as never;
                    }
            }
            setState({
                ...state,
                allTotal: data.allTotal,
                reload: false
            })
        }).catch((error) => {
            setState({
                ...state,
                errorMessage: t ? t('errorLoadingDashboard') : 'Ocurrió un error al cargar el dashboard.',
                reload: true
            })
            console.error('Dashboard error:', error);
        });
    }

    const getTotalsByIssuerAndCurrency = (tranId: string) => {
        TransactionService.getTotalsByIssuerAndCurrency(tranId).then((response: AxiosResponse<IIssuerTotalDto[]>) => {
            setState({
                ...state,
                show: true,
                issuersByTotal: response.data,
                tranId: tranId
            });
        }).catch(error => console.log('error:', error));
    }

    const processAction = (event: any, transaction: ITransaction) => {
        event.preventDefault();
        getTotalsByIssuerAndCurrency(transaction?.id);
    }

    const loadCarouselImages = async () => {
        await getAllImages().then(response => {
            setState({
                ...state,
                carouselImages: response.sort((a, b) => Number(a.priority) - Number(b.priority))
            })
        });
    }

    useEffect(() => {
        loadCarouselImages();
        window.setTimeout(function () {
            loadCarouselImages();
        }, 5000);
    }, []);

    const redirectToLink = (link: string) => {
        if (link) {
            window.open(link, '_blank');
        }
    };

    const handleCurrencyChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        const selectedCurrencyId = event.target.value;
        setSelectedCurrency(selectedCurrencyId);
        const selectedCurrencyOption = WebCache.getCurrencies().find(currency => currency?.id === selectedCurrencyId);
        if (selectedCurrencyOption) {
            setDashboardLoaded(false)
            setState(prevState => ({
                ...prevState,
                currency: {
                    id: selectedCurrencyOption?.id,
                    name: selectedCurrencyOption.name
                }
            }));
            setTransactionsLoaded(false);
        }
    };

    let onMainDashboardOpen = (): void => {
        setAccordionOpen(!accordionOpen);
        setState({ ...state, fetchMainDashboard: !state.fetchMainDashboard })
        if (!state.fetchMainDashboard)
            setDashboardLoaded(false)
    }

    let handleTimeRangeChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        state.dateRange = event.target.value;
        refreshData(true);
    }

    const getCurrencySymbol = (): string => {
        return CurrencyHelper.getCurrencySymbol(state.currency?.id);
    }

    const netAmountIndicatorTitle = (): string => {
        return (state.dateRange === "today") ? t("amountToChargeToday") : t("chargedAmount");
    }

    const transactionColumns = TransactionColumns({
        t,
        processAction,
        showCouponColumn: false
    });

    useEffect(() => {
        if (localStorage.getItem('nps_pending_login') === 'true') {
            localStorage.removeItem('nps_pending_login');
            setShowNpsModal(true);
        }
    }, []);

    /*
        Function that is responsible for filtering the data from the pie's dashboard graphics that come with "?" in their labels.
    */
    function filterPieChartData(data: IPieChartData): IPieChartData {
        const filteredData: IPieChartData = {
            labels: [],
            colors: [],
            values: [],
            counts: [],
        }
        for (let i = 0; i < data.labels.length; i++) {
            const label = data.labels[i];
            if (label !== "?") {
                // Data with label different from "?" is aded to the returned filtered data.
                filteredData.labels.push(label as never);
                filteredData.colors.push(data.colors[i] as never);
                filteredData.values.push(data.values[i] as never);
                filteredData.counts.push(data.counts[i]);
            }
        }
        return filteredData;
    }

    /*
        Function that is responsible for filtering the data from the pie's dashboard graphics that come with "?" in their labels.
    */
    function filterRejectionIndicators(data: IRejectionIndicator): IRejectionIndicator {
        const filteredData: IRejectionIndicator = {
            labels: [],
            colors: [],
            values: [],
            counts: [],
            authValues: [],
            authCounts: [],
            totalCount: data.totalCount,
        };

        for (let i = 0; i < data.labels.length; i++) {
            const label = data.labels[i];
            if (label !== "?") {
                // Append non-"?" labels to filtered data
                filteredData.labels.push(label as never);
                filteredData.colors.push(data.colors[i] as never);
                filteredData.values.push(data.values[i] as never);
                filteredData.counts.push(data.counts[i]);
                filteredData.authValues.push(data.authValues[i]);
                filteredData.authCounts.push(data.authCounts[i]);
            } else {
                // Subtract counts for "?" labels from totalCount to consider the reduced amount from the substracted data with "?" labels.
                filteredData.totalCount -= data.counts[i];
            }
        }
        return filteredData;
    }

    const componentRef: RefObject<any> = useRef();

    function GetConciliationIndicators() {
        if (!WebCache.GetConciliationData().disableCalendar)
            return (<React.Fragment >
                <NetAmountIndicator t={t} dateRange={state.dateRange} upToDate={state.upToDate} title={netAmountIndicatorTitle()} infoTooltip={t(`${T_PREFIX}chargedAmountInfoTooltip`)} chartData={state.conciliationShortPeriodIndicator} currencySymbol={getCurrencySymbol()}></NetAmountIndicator>
                <NetAmountIndicator t={t} dateRange={state.dateRange} upToDate={true} title={t(`${T_PREFIX}amountToCharge`)} infoTooltip={t(`${T_PREFIX}amountToChargeInfoTooltip`)} chartData={state.conciliationNextPeriodIndicator} currencySymbol={getCurrencySymbol()}></NetAmountIndicator>
                {/*<ReturnIndicator t={t} dateRange={state.dateRange} title={t(`${T_PREFIX}contracChargeAmount`)} infoTooltip={t(`${T_PREFIX}contracChargeAmountInfoTooltip`)} chartData={ state.conciliationShortPeriodIndicator} currencySymbol={getCurrencySymbol()}></ReturnIndicator>*/}
                <TariffIndicator t={t} dateRange={state.dateRange} title={t(`${T_PREFIX}tariffAmount`)} infoTooltip={t(`${T_PREFIX}tariffAmountInfoTooltip`)} chartData={state.conciliationShortPeriodIndicator} currencySymbol={getCurrencySymbol()}></TariffIndicator>
                <TaxIndicator t={t} dateRange={state.dateRange} title={t(`${T_PREFIX}taxAmount`)} infoTooltip={t(`${T_PREFIX}taxAmountInfoTooltip`)} chartData={state.conciliationShortPeriodIndicator} currencySymbol={getCurrencySymbol()}></TaxIndicator>
            </React.Fragment>)
        return (<></>)
    }

    return (
        <Page>
            <>
                <div ref={componentRef}>
                    {/* {state.carouselImages[0]?.text} */}
                    <div className={`row mb-5 ${state.carouselImages?.length === 0} `}>
                        <div className="col-md-12">
                            <Carousel fade interval={5000}
                                controls={state.carouselImages.length > 1}
                                indicators={state.carouselImages.length > 1}>
                                {state.carouselImages.map((img, idx) => (
                                    <Carousel.Item key={idx}>
                                        <img
                                            className="d-block w-100"
                                            src={img.image}
                                            alt={img.text || `slide-${idx}`}
                                            onClick={() => redirectToLink(img.link)}
                                        />
                                        {img.text && (
                                            <Carousel.Caption>
                                                <p>{img.text}</p>
                                            </Carousel.Caption>
                                        )}
                                    </Carousel.Item>
                                ))}
                            </Carousel>
                        </div>
                    </div>
                    <div className="row">
                        {/* <div className="form-group col-md-4 mt-5">
                        </div> */}
                        <div className="form-group menuDashboard">
                            <div className='row w-100'>
                                <div className="col-md-6">
                                    <h2 className='d-flex align-items-center justify-content-start  mb-0'>{t(`${T_PREFIX}dashboard`)}</h2>
                                </div>
                                <div className="col-md-6">
                                    <div className='d-flex d-inline-block align-items-center justify-content-center float-right'>
                                        {UtilService.isMobilePlatform() ? (
                                            <div className="currencySelect zIndex1 currency-input">
                                                <Select
                                                    options={currencyOptions}
                                                    value={currencyOptions.find(opt => opt.value === selectedCurrency) || currencyOptions[0]}
                                                    onChange={(selectedOption: { value: string; label: React.ReactNode } | null) => {
                                                        if (selectedOption) {
                                                            setSelectedCurrency(selectedOption.value);
                                                            handleCurrencyChange({ target: { value: selectedOption.value } } as React.ChangeEvent<HTMLSelectElement>);
                                                        }
                                                    }}
                                                    classNamePrefix="react-select"
                                                    isSearchable={false}
                                                    menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                    menuPosition="fixed"
                                                    styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                                                />
                                            </div>
                                        ) : (
                                            <div className='currencySelect zIndex1 currency-input'>
                                                <select
                                                    name="country"
                                                    className="form-control form-select form-select-lg select2 currencyStyle"
                                                    value={selectedCurrency}
                                                    onChange={handleCurrencyChange}
                                                >
                                                    {WebCache.getCurrencies().map((currency) => (
                                                        <option key={currency?.id} value={currency?.id}>
                                                            {currency.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}
                                        <select className="p-3 form-control zIndex1 form-select form-select-lg select2 itemDashboard" value={state.dateRange} onChange={handleTimeRangeChange}>
                                            <option value="today">{t('today')}</option>
                                            <option value="yesterday">{t('yesterday')}</option>
                                            <option value="7days">7 {t('days')}</option>
                                            <option value="30days">30 {t('days')}</option>
                                            <option value="1year">1 {t('year')}</option>
                                        </select>
                                        <div className='divExport'>
                                            <ReactToPrint
                                                trigger={() => <button name="country" className="form-control form-select form-select-lg select2  bg-primary text-white"  >
                                                    {t(`${T_PREFIX}Export`)}
                                                </button>}
                                                content={() => componentRef.current}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" id="dashboard-panel">
                        {GetConciliationIndicators()}
                        <Accordion>
                            <Accordion.Item className='mt-4' key="mainDashboard" eventKey="mainDashboard" onClick={onMainDashboardOpen}>
                                <Accordion.Header>
                                    {accordionOpen ? (
                                        <div className="d-flex justify-content-start align-items-center w-100">
                                            <i className="fa-solid fa-minus"></i>
                                            <span className='textAccordion'>{"Info"}</span>
                                        </div>
                                    ) : (
                                        <div className="d-flex justify-content-start align-items-center w-100 ">
                                            <i className="fa-solid fa-plus"></i>
                                            <span className='textAccordion'>{"Info"}</span>
                                        </div>
                                    )}
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className="row" id="dashboard-panel">
                                        <CountIndicator t={t} dateRange={state.dateRange} title={t(`${T_PREFIX}salesTotalTitle`)} infoTooltip={t(`${T_PREFIX}salesTotalInfoTooltip`)} chartData={state.shortPeriodIndicator} currencySymbol={getCurrencySymbol()}></CountIndicator>
                                        <AmountIndicator t={t} dateRange={state.dateRange} title={t(`${T_PREFIX}totalAmountForReport`)} infoTooltip={t(`${T_PREFIX}totalAmountForReportInfoTooltip`)} chartData={state.shortPeriodIndicator} currencySymbol={getCurrencySymbol()}></AmountIndicator>
                                        <CouponPromIndicator t={t} dateRange={state.dateRange} title={t(`${T_PREFIX}couponPromIndicator`)} infoTooltip={t(`${T_PREFIX}couponPromIndicatorInfoTooltip`)} chartData={state.shortPeriodIndicator} currencySymbol={getCurrencySymbol()}></CouponPromIndicator>
                                        {WebCache.isUserUYU() && (
                                            <ApprovalRateIndicator t={t} dateRange={state.dateRange} title={t(`${T_PREFIX}approvalRateIndicator`)} infoTooltip={t(`${T_PREFIX}approvalRateIndicatorInfoTooltip`)} chartData={state.approvalRateIndicator} currencySymbol={getCurrencySymbol()} />
                                        )}
                                        {
                                            UtilService.isSmallScreen() ||
                                            <>
                                                <div className="col-md-6 salesQuantity">
                                                    <Card title={t(`${T_PREFIX}salesQuantity`)}>
                                                        <CountByIssuerChart currencySymbol={getCurrencySymbol()} dateRange={state.dateRange} shortPeriodChartData={state.shortPeriodIndicator} chartData={state.issuerTotals} infoTooltip={t(`${T_PREFIX}countByIssuerInfoTooltip`)} approvalRateIndicator={state.approvalRateIndicator} ></CountByIssuerChart>
                                                    </Card>
                                                </div>
                                                <div className="col-md-6 grossAmount">
                                                    <Card title={t(`${T_PREFIX}grossAmountCamelCase`)} >
                                                        <AmountByIssuerChart currencySymbol={getCurrencySymbol()} dateRange={state.dateRange} shortPeriodChartData={state.shortPeriodIndicator} chartData={state.issuerTotals} infoTooltip={t(`${T_PREFIX}amountByIssuerInfoTooltip`)}></AmountByIssuerChart>
                                                    </Card>
                                                </div>
                                            </>
                                        }
                                        {UtilService.isSmallScreen() || <SalesChart name={t(`${T_PREFIX}salesEvolution`)} chartData={state.allTotal} />}
                                        {/*<PeriodIndicator t={t} dateRange={state.dateRange} chartData={ state.shortPeriodIndicator} currencySymbol={getCurrencySymbol()}></PeriodIndicator>
                        <PeriodIndicator t={t} dateRange={state.dateRange} chartData={state.longPeriodIndicator} currencySymbol={getCurrencySymbol()}></PeriodIndicator>
                        <RejectionIndicator t={t} dateRange={state.dateRange} chartData={state.rejectionIndicators}></RejectionIndicator>
                        <ReverseIndicator t={t} dateRange={state.dateRange} chartData={state.reverseIndicators}></ReverseIndicator>*/}
                                        {WebCache.isUserUYU() ? <RejectionByIssuerChart currencySymbol={getCurrencySymbol()} name={"rejectionByIssuer"} chartData={state.rejectionIndicators} /> :
                                            <RankingChart chartData={state.totalByWallet} currencySymbol={getCurrencySymbol()} bgColor="#FFC626" title={t(`${T_PREFIX}rankingWallet`)} name="rankingWallet" />}
                                        {/*<IssuerChart chartData={state.issuerTotals} />*/}
                                        <CardTypeChart name={"totalByChannel"} chartData={state.totalByChannel} currencySymbol={getCurrencySymbol()} />
                                        <CardTypeChart name={"paymentModes"} chartData={state.cardTypeTotals} currencySymbol={getCurrencySymbol()} />
                                        {WebCache.isUserUYU() &&<RankingChart chartData={state.acquirerTotals} currencySymbol={getCurrencySymbol()} bgColor="#823078" title={t(`${T_PREFIX}acquirerRanking`)} name="acquirerRanking" />}
                                        <RankingChart chartData={state.planTotals} currencySymbol={getCurrencySymbol()} bgColor="#9B9B9B" title={t(`${T_PREFIX}rankingPurchases`)} name="rankingPurchases" colSize={WebCache.isUserUYU()?"col-lg-4":"col-lg-6"}/>
                                        <RankingChart chartData={state.totalByBrand} currencySymbol={getCurrencySymbol()} bgColor="#FFC626" title={t(`${T_PREFIX}rankingBrands`)} name="rankingBrands" colSize={WebCache.isUserUYU()?"col-lg-4":"col-lg-6"}/>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                        <div className="col-md-12 mt-3">
                            <div className="card">
                                <div className="card-header">
                                    <h2 className="card-title">{t(`${T_PREFIX}lastTransactions`)}</h2>
                                </div>
                                {UtilService.isMobilePlatform() ?
                                    <div>
                                        <div className="container">
                                            <ul className="notification">
                                                {
                                                    transactions.map((transaction, Tindex) => {
                                                        return (
                                                            <li>
                                                                <div className="notification-time-date mb-2 d-block d-md-none">
                                                                    <span className="date">{transaction.authDateTime}</span>
                                                                </div>
                                                                <div className={"settlementMobile notification-body transactionType-" + transaction.transactionType}>
                                                                    <div className="media mt-0">
                                                                        <div className="main-avatar avatar-md online" >
                                                                            {<img alt="avatar" className="br-7 transaction-image" src={UtilService.getImageTag(t("issuer-" + transaction.issuer).toUpperCase())}></img>
                                                                            }
                                                                        </div>
                                                                        <div className="media-body ms-3 d-flex">
                                                                            <div className="" >
                                                                                <span className={transaction.transactionType == "REV" || transaction.transactionType == "LP" || transaction.transactionType == "A" || transaction.transactionType == "D" ? "text-danger amount-label" : "amount-labelSettlement"}>{Intl.NumberFormat('es-UY', {
                                                                                    style: 'currency',
                                                                                    currency: CurrencyHelper.getCurrencySymbol(transaction.currency)
                                                                                }).format(transaction.totalAmountForReport)}</span>
                                                                                <p className="mb-0 fs-13 text-muted">{t("transactionType-" + transaction.transactionType)}</p>
                                                                                <p className="mb-0 fs-13 text-muted">{transaction.cardNumber}</p>
                                                                                <p className={
                                                                                    "mb-0 fs-11 " +
                                                                                    (
                                                                                        transaction.responseCode === "00" ||
                                                                                            transaction.responseCode === "08" ||
                                                                                            transaction.responseCode === "11" ||
                                                                                            transaction.responseCode === "85" ||
                                                                                            transaction.responseCode === "LV" ||
                                                                                            transaction.responseCode === "OF"
                                                                                            ? "response-code-success"
                                                                                            : "response-code-error"
                                                                                    )
                                                                                }>
                                                                                    {transaction.responseCode
                                                                                        ? t("responseCode-" + transaction.responseCode)
                                                                                        : "-"}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        )
                                                    })}
                                            </ul>
                                        </div>
                                    </div>
                                    : <div className="card-body">
                                        <CustomTable
                                            rowObjects={transactions}
                                            columnDefinitions={transactionColumns}
                                            config={{
                                                mode: TableModeEnum.LIST
                                            }}
                                        ></CustomTable>
                                    </div>
                                }
                            </div>
                        </div>

                    </div>
                </div>
                <Modal show={state.show} size="lg">
                    <div className="modal-content modal-content-demo">
                        <div className="modal-header bg-primary">
                            <h5 className="modal-title text-white"> {'Transacción Nro. ' + state.tranId}  </h5>
                            <button aria-label="Close" className="btn-close" onClick={() => setState({ ...state, show: false })}><span className='text-white' aria-hidden="true">&times;</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="col-md-12 mb-3">
                                <div className="table-responsive">
                                    <table className="table text-nowrap text-md-nowrap mb-0">
                                        <thead>
                                            <tr >
                                                <th style={{ color: "black" }}>{t("issuer")}</th>
                                                <th style={{ color: "black" }}>{t("amount")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                state.issuersByTotal.map((val: IIssuerTotalDto) => {
                                                    return (
                                                        <tr >
                                                            <td>{val.issuerName}</td>
                                                            <td>{Intl.NumberFormat('es-UY', {
                                                                style: 'currency',
                                                                currency: val.currency == "$" ? "UYU" : "USD"
                                                            }).format(Number(val.totalAmount))}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button onClick={() => setState({ ...state, show: false })}
                                className="btn btn-light"
                                style={{
                                    backgroundColor: '#f60'
                                    ,
                                    color: 'white',
                                }}
                                data-bs-dismiss="modal">OK</button>
                        </div>
                    </div>
                </Modal>
                {showNpsModal && (
                    <NpsSurvey eventId="" onClose={() => setShowNpsModal(false)} />
                )}
            </>
        </Page>
    )
}
export default Dashboard;
